import { Link } from 'react-router-dom';

// icons
import { faFileCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { Grid, useTheme } from '@mui/material';

// components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActor } from '../../../../components/hooks/useActor';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export const RenewReady = ({ quote }: any) => {
  const actor = useActor();
  const theme = useTheme();

  let availableUrl = `/customer/quotes/${quote.id}/renewals/${quote.product}/approve`;

  if (quote.customerEmail !== actor.email) {
    availableUrl = `/customer/quotes/${quote.id}/insuredName/${quote.product}`;
  }

  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileCircleQuestion}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Policy Renewal</StyledHeader>
        <StyledParagraph>
          Renewal Quote(s) are ready for your review and approval
        </StyledParagraph>
        <Link style={{ display: 'block' }} to={availableUrl}>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            Renew
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
